/*
 * RESADE rs-lieferdatum.js (E-161, 28.09.2026; Denny: „dem Kunden ein Datum mitgeben … ein bis zwei Tage Versandzeit“).
 * Füllt jedes [data-rs-lieferdatum] (snippets/rs-lieferdatum.liquid) mit dem Ankunftsfenster, etwa
 * „Ankunft mit DHL: Mi., 30.09. bis Do., 01.10.“. Klassisches Skript mit defer, geladen von
 * sections/rs-warenkorb-drawer.liquid, nur wenn settings.rs_lieferdatum_an an ist.
 *
 * Regeln (AGB § 7.2 und § 7.3, Rechts-Check Runde 9 F):
 *  - Zeitzone Europe/Berlin über Intl, nie die Zeitzone des Geräts.
 *  - Versandtag: heute, wenn Mo. bis Fr. vor dem Versandschluss, kein Feiertag und nicht in der Versandpause, sonst
 *    der nächste solche Tag. Seit E-168 kommt der Schluss aus data-schluss (settings.rs_versand_schluss) und die Pause
 *    aus data-pause-von und data-pause-bis (JJJJ-MM-TT, beide Tage zählen mit); „bis 15 Uhr“ aus rs_versand_text bleibt
 *    Rückfall ohne data-schluss. Die Spanne kommt aus rs_liefer_text („1 bis 2 Werktage“). Lässt sich etwas nicht lesen,
 *    nennt der Versandtext eine andere Uhrzeit als data-schluss, ist nur ein Pausendatum gesetzt oder liegt das Ende
 *    vor dem Anfang, bleibt der feste Satz stehen.
 *  - Ankunft: Versandtag plus die Spanne in Werktagen. Werktag heißt hier Mo. bis Fr. ohne Feiertag; der Samstag
 *    zählt nicht, das Fenster fällt also eher später aus als die AGB versprechen, nie früher. Die Versandpause zählt
 *    dabei nicht mit, DHL stellt auch in der Pause zu.
 *  - Feiertage: bundesweit plus Rheinland-Pfalz (Fronleichnam, Allerheiligen, dort wird versendet), aus Ostern
 *    gerechnet, keine Liste, die abläuft. Liegt ein Feiertag nur einzelner Länder im Fenster (Empfänger vor der Kasse
 *    unbekannt), rückt das Ende einen Werktag weiter.
 *  - Uhr-Probe: Liquid gibt die Serverzeit mit (data-server, Sekunden). Geht die Uhr des Geräts mehr als 10 Minuten
 *    nach oder mehr als 48 Stunden vor, bleibt der feste Satz (die abgelöste Fassung hing an der Uhr des Kunden).
 *  - Dieses Skript hat keinen Takt und keinen Speicher, kein „voraussichtlich“. Neu gerechnet wird beim Zurückkehren
 *    in den Tab und nach Warenkorb-Ereignissen, die nur gelesen werden. Die Restzeit bis zum Versandschluss rechnet es
 *    in Minuten mit (rest); zeigen und nachführen tut sie allein assets/rs-versandschluss.js auf der Warenkorbseite
 *    (E-168, seit dem 02.10.2026 als Uhr mit Sekunden, die es selbst rechnet).
 *  - Serverzeit (E-168): versatz(ms) übernimmt den Abstand zur Uhr des Servers, den rs-versandschluss.js einmal misst;
 *    jetzt() ist Date.now() plus dieser Abstand, fuellen() rechnet damit.
 * window.RSLieferdatum (Prüfung in Node):
 *  - rechnen(ms, { min, max, schluss, pause }) gibt { heute, versand, von, bis, rest } zurück. Die Tage sind
 *    UTC-Mitternacht des Berliner Datums, pause ist { von, bis } in derselben Form oder fehlt. rest sind die ganzen
 *    Minuten bis zum Schluss (abgerundet, mindestens 1), wenn heute versendet wird, sonst null.
 *  - lesen(el) gibt { min, max, schluss, schlussText, pause } oder null, tagText(t) etwa „Montag, 05.10.“; dazu
 *    fuellen(), jetzt() und versatz(ms).
 */
(() => {
  'use strict';
  if (window.RSLieferdatum) return;

  const TAG = 86400000;
  const KURZ = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  const LANG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  // Ostersonntag nach Gauß (gregorianisch), als UTC-Mitternacht
  function ostern(j) {
    const a = j % 19;
    const b = Math.floor(j / 100);
    const c = j % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = h + l - 7 * m + 114;
    return Date.UTC(j, Math.floor(n / 31) - 1, (n % 31) + 1);
  }

  const jahre = {};
  function feiertage(j) {
    if (jahre[j]) return jahre[j];
    const o = ostern(j);
    const d = (monat, tag) => Date.UTC(j, monat - 1, tag);
    // Kein Versand und keine Zustellung: bundesweit, dazu Rheinland-Pfalz (Versandort)
    const frei = [
      d(1, 1), o - 2 * TAG, o + TAG, d(5, 1), o + 39 * TAG, o + 50 * TAG, d(10, 3), d(12, 25), d(12, 26),
      o + 60 * TAG, d(11, 1)
    ];
    // Nur einzelne Länder: Heilige Drei Könige, Frauentag, Mariä Himmelfahrt, Weltkindertag, Reformationstag,
    // Buß- und Bettag (Mittwoch vor dem 23. November)
    const nov23 = d(11, 23);
    const zurueck = (new Date(nov23).getUTCDay() - 3 + 7) % 7 || 7;
    const land = [d(1, 6), d(3, 8), d(8, 15), d(9, 20), d(10, 31), nov23 - zurueck * TAG];
    jahre[j] = { frei: new Set(frei), land: new Set(land) };
    return jahre[j];
  }

  const wochentag = (t) => new Date(t).getUTCDay();
  const jahr = (t) => new Date(t).getUTCFullYear();
  const werktag = (t) => {
    const w = wochentag(t);
    return w >= 1 && w <= 5 && !feiertage(jahr(t)).frei.has(t);
  };
  const naechster = (t) => {
    let x = t + TAG;
    while (!werktag(x)) x += TAG;
    return x;
  };

  // E-168: Versandtag heißt Werktag außerhalb der Versandpause (pause: { von, bis }, beide Tage zählen mit)
  const versandtag = (t, pause) => werktag(t) && !(pause && t >= pause.von && t <= pause.bis);
  const naechsterVersandtag = (t, pause) => {
    let x = t + TAG;
    while (!versandtag(x, pause)) x += TAG;
    return x;
  };

  // Berliner Datum (UTC-Mitternacht), Minuten seit Mitternacht und Sekunden der Minute zu einem Zeitpunkt
  let format = null;
  function berlin(ms) {
    if (!format) {
      format = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
      });
    }
    const t = {};
    format.formatToParts(new Date(ms)).forEach((p) => { t[p.type] = p.value; });
    return {
      tag: Date.UTC(Number(t.year), Number(t.month) - 1, Number(t.day)),
      minuten: (Number(t.hour) % 24) * 60 + Number(t.minute),
      sekunden: Number(t.second) || 0
    };
  }

  function rechnen(ms, o) {
    const b = berlin(ms);
    const pause = o.pause || null;
    // Schluss in ganzen Minuten: o.schluss ist eine Kommazahl (16:10 Uhr ergibt 16,1666…), mal 60 nicht immer genau
    const schlussMin = Math.round(o.schluss * 60);
    const versand = versandtag(b.tag, pause) && b.minuten < schlussMin ? b.tag : naechsterVersandtag(b.tag, pause);
    let von = versand;
    for (let i = 0; i < o.min; i++) von = naechster(von);
    let bis = versand;
    for (let i = 0; i < o.max; i++) bis = naechster(bis);
    let land = false;
    for (let x = versand + TAG; x <= bis; x += TAG) {
      const w = wochentag(x);
      if (w >= 1 && w <= 5 && feiertage(jahr(x)).land.has(x)) land = true;
    }
    if (land) bis = naechster(bis);
    // E-168: Restzeit in ganzen Minuten, abgerundet, nie 0. Die Zeitumstellung fällt immer auf einen Sonntag, also nie
    // auf einen Versandtag; die Minuten seit Mitternacht stimmen an jedem Versandtag. Millisekunden wie in UTC.
    let rest = null;
    if (versand === b.tag) {
      const bisSchluss = schlussMin * 60000 - (b.minuten * 60000 + b.sekunden * 1000 + (((ms % 1000) + 1000) % 1000));
      rest = Math.max(1, Math.floor(bisSchluss / 60000));
    }
    return { heute: b.tag, versand, von, bis, rest };
  }

  // E-168: Datum JJJJ-MM-TT als UTC-Mitternacht, sonst null (auch bei 2026-13-01 oder 2026-02-30)
  function datumLesen(text) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(text || '').trim());
    if (!m) return null;
    const j = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const d = Number(m[3]);
    const t = Date.UTC(j, mo, d);
    const x = new Date(t);
    return x.getUTCFullYear() === j && x.getUTCMonth() === mo && x.getUTCDate() === d ? t : null;
  }

  function lesen(el) {
    const l = /(\d+)\s*bis\s*(\d+)\s*Werktag/.exec(el.getAttribute('data-liefer') || '');
    const v = /bis\s*(\d{1,2})(?:[:.](\d{2}))?\s*Uhr/.exec(el.getAttribute('data-versand') || '');
    if (!l) return null;
    const min = Number(l[1]);
    const max = Number(l[2]);
    if (!(min >= 0 && max >= min && max <= 10)) return null;
    // E-168: der Schluss aus der Einstellung (data-schluss) hat Vorrang, „bis 15 Uhr“ im Versandtext ist Rückfall.
    // Nennt der Versandtext eine andere Uhrzeit, gilt keines von beiden: fester Satz.
    const roh = (el.getAttribute('data-schluss') || '').trim();
    let std;
    let mnt;
    let schlussText;
    if (roh) {
      std = Number(roh);
      mnt = 0;
      if (!Number.isInteger(std)) return null;
      if (v && (Number(v[1]) !== std || (v[2] ? Number(v[2]) : 0) !== 0)) return null;
      schlussText = String(std);
    } else {
      if (!v) return null;
      std = Number(v[1]);
      mnt = v[2] ? Number(v[2]) : 0;
      schlussText = v[2] ? std + ':' + v[2] : String(std);
    }
    if (!(std >= 1 && std <= 23 && mnt < 60)) return null;
    // Versandpause nur mit beiden Daten, gültig, das Ende nicht vor dem Anfang und höchstens ein Jahr lang
    const pv = (el.getAttribute('data-pause-von') || '').trim();
    const pb = (el.getAttribute('data-pause-bis') || '').trim();
    let pause = null;
    if (pv || pb) {
      const von = datumLesen(pv);
      const bis = datumLesen(pb);
      if (von === null || bis === null || bis < von || bis - von > 366 * TAG) return null;
      pause = { von, bis };
    }
    return { min, max, schluss: std + mnt / 60, schlussText, pause };
  }

  const zwei = (n) => (n < 10 ? '0' : '') + n;
  const datum = (t) => zwei(new Date(t).getUTCDate()) + '.' + zwei(new Date(t).getUTCMonth() + 1) + '.';
  const kurz = (t) => KURZ[wochentag(t)] + ', ' + datum(t);
  const tagText = (t) => LANG[wochentag(t)] + ', ' + datum(t);

  // Muster mit {von} und {bis}; jedes Datum bleibt zusammen (white-space: nowrap)
  function setzen(ziel, muster, werte) {
    ziel.textContent = '';
    String(muster).split(/(\{von\}|\{bis\})/).forEach((teil) => {
      if (!teil) return;
      const schluessel = teil === '{von}' ? 'von' : teil === '{bis}' ? 'bis' : null;
      if (schluessel) {
        const s = document.createElement('span');
        s.className = 'rs-lieferdatum__tag';
        s.textContent = werte[schluessel];
        ziel.appendChild(s);
      } else ziel.appendChild(document.createTextNode(teil));
    });
  }

  function uhrPasst(el, ms) {
    const s = Number(el.getAttribute('data-server'));
    if (!Number.isFinite(s) || s <= 0) return false;
    const abstand = ms - s * 1000;
    return abstand > -10 * 60000 && abstand < 48 * 3600000;
  }

  // E-168: Abstand zur Serveruhr in ms (rs-versandschluss.js misst ihn über den Date-Kopf von /cart.js)
  let serverAbstand = 0;
  function versatz(ms) {
    if (typeof ms === 'number' && Number.isFinite(ms)) serverAbstand = ms;
    return serverAbstand;
  }
  const jetzt = () => Date.now() + serverAbstand;

  function fuellen() {
    const ms = jetzt();
    document.querySelectorAll('[data-rs-lieferdatum]').forEach((el) => {
      const js = el.querySelector('[data-rs-ld-js]');
      const fest = el.querySelector('[data-rs-ld-fest]');
      const fenster = el.querySelector('[data-rs-ld-fenster]');
      const o = lesen(el);
      if (!js || !fenster || !o || !uhrPasst(el, ms)) {
        if (js) js.hidden = true;
        if (fest) fest.hidden = false;
        return;
      }
      const r = rechnen(ms, o);
      const muster = r.von === r.bis
        ? el.getAttribute('data-muster-ein') || 'Ankunft mit DHL: {von}'
        : el.getAttribute('data-muster') || 'Ankunft mit DHL: {von} bis {bis}';
      setzen(fenster, muster, { von: kurz(r.von), bis: kurz(r.bis) });
      const versand = el.querySelector('[data-rs-ld-versand]');
      if (versand) {
        const m = (r.versand === r.heute ? el.getAttribute('data-muster-heute') : el.getAttribute('data-muster-spaeter')) || '';
        versand.textContent = m.replace('{schluss}', o.schlussText).replace('{tag}', tagText(r.versand));
        versand.hidden = !versand.textContent;
      }
      js.hidden = false;
      if (fest) fest.hidden = true;
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) fuellen();
  });
  ['rs:warenkorb:geaendert', 'rs:warenkorb:geoeffnet'].forEach((name) => document.addEventListener(name, fuellen));
  fuellen();

  window.RSLieferdatum = Object.freeze({ rechnen, fuellen, lesen, jetzt, versatz, tagText });
})();
